const register = {
  loginCredentials: "Διαπιστευτήρια σύνδεσης", // translated
  companyInformation: "Στοιχεία της εταιρείας", // translated
  contactDetails: "Στοιχεία επικοινωνίας", // translated
  businessName: "Επωνυμία Επιχείρησης", // translated
  businessAddress: "Διεύθυνση επιχείρησης", // translated
  registrationCode: "Κωδικός εγγραφής", // translated
  websiteUrl: "Διεύθυνση Ιστοσελίδας", // translated
  mobilePhone: "Κινητό τηλέφωνο", // translated
  regionStateProvince: "Περιφέρεια/Πολιτεία/Επαρχία", // translated
  legalTitle: "Νομικός Τίτλος", // translated
  city: "Πόλη", // translated
  postalCode: "Ταχυδρομικός Κώδικας", // translated
  registrationSuccess: "Επιτυχία εγγραφής.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Περιμένετε λίγα λεπτά και θα ανακατευθυνθείτε στην αρχική σελίδα.", // translated
};

export default register;
